<template lang="pug">
  div(v-click-outside="hide")
    .select-choice-modal(@click="stopPropagation" :class="{'select-choice-modal-jobtype': user.has_basic && user.search_jobtype_ai}")
      .select-choice-modal-title 職種を選択する
      .jobtype-support-box(v-if="user.has_basic && user.search_jobtype_ai")
        p テキストと合致する職種を選択
        input.text-box(type="text" v-model="jobtypeText" placeholder="例）システムエンジニア")
        .button-check-area(v-if="isLoading")
          input.button-check.disabled(type="button" value="チェック中・・・" :disabled="true")
        .button-check-area(v-else)
          input.button-check(type="button" value="チェック" @click="recommendJobtype" :class="{ disabled: !activateJobtypeCheckButton }")
      .select-choice-modal-sidebar(:class="{'select-choice-modal-jobtype-sidebar': user.has_basic && user.search_jobtype_ai}")
        ul
          li(
            v-for="option in jobtypeClasses"
            :value="option.code"
            :class="isActiveJobtypeClass(option.code) ? 'active' : ''"
          )
            a(@click="selectJobtypeClass(option.code)") {{ option.name }}
              template(v-if="isActiveJobtypeClass(option.code)")
                span.label-selected 選択中
      .select-choice-modal-main.select-choice-modal-main-jobtype
        p.check-all
          label.checkbox
            input(type="checkbox" v-model="allChecked" @click="checkAll")
            span すべて
        p
          label.checkbox(v-for="jobtype in displayJobtypes")
            input(type="checkbox" :value="jobtype.code" v-model="jobtypeCodes")
            span {{ jobtype.name }}
        p.select-choice-modal-button
          input.button-main(type="button" value="設定する" @click="submit")
    .modal-cover(@click="hide")
</template>

<script>
  import { mapState } from 'vuex'
  import ClickOutside from 'vue-click-outside'
  import { api } from '../../libs/api'

  export default {
    directives: { ClickOutside },
    props: ['openJobtypeModal', 'selectedJobtypeCd', 'filteredAp'],
    mounted () {
      this.popupItem = this.$el
    },
    data () {
      return {
        allChecked: false,
        displayJobtypes: [],
        jobtypeClassCode: 0,
        jobtypeClassCodes: new Set(),
        jobtypeCodes: [],
        jobtypeText: '',
        isLoading: false,
      }
    },
    computed: {
      ...mapState({
        jobtypeClasses: state => state.master.jobtypeClasses,
        jobtypes: state => state.master.jobtypes,
        user: state => state.user.detail,
      }),
      activateJobtypeCheckButton () {
        if (this.jobtypeText === '') {
          return false
        }
        return true
      },
    },
    watch: {
      openJobtypeModal () {
        this.selectJobtypeClass(this.$store.state.master.jobtypeClasses[0].code)

        const jobtypeCd = this.selectedJobtypeCd
        this.jobtypeCodes = jobtypeCd.map(j => j.value)
      },
      jobtypeCodes () {
        const jobtypes = this.jobtypeCodes.map(c => this.jobtypes.find(j => j.code === c))
        this.jobtypeClassCodes = new Set(jobtypes.map(j => j.parent_cd))
        this.setAllCheck()
      },
    },
    methods: {
      checkAll (e) {
        const codes = this.displayJobtypes.map(j => j.code)
        if (e.currentTarget.checked) {
          this.jobtypeCodes = [...new Set(this.jobtypeCodes.concat(codes))]
        } else {
          this.jobtypeCodes = this.jobtypeCodes.filter(c => !codes.includes(c))
        }
      },
      stopPropagation (e) {
        e.stopPropagation()
      },
      isActiveJobtypeClass (jobtypeClassCode) {
        return this.jobtypeClassCodes.has(jobtypeClassCode)
      },
      selectJobtypeClass (jobtypeClassCode) {
        this.jobtypeClassCode = jobtypeClassCode
        this.displayJobtypes = this.jobtypes.filter(j => j.parent_cd === jobtypeClassCode)
        this.setAllCheck()
      },
      setAllCheck () {
        const displaySelectedCount = this.displayJobtypes.filter(j =>
          this.jobtypeCodes.includes(j.code)).length
        const displayJobtypesCount = this.displayJobtypes.length
        this.allChecked =
          displayJobtypesCount !== 0 && displayJobtypesCount === displaySelectedCount
      },
      submit () {
        const jobtypes = this.jobtypeCodes.map(c => this.jobtypes.find(j => j.code === c))
        const jobtypeCodes = jobtypes.map(j => ({ label: j.name, value: j.code }))
        this.$emit('setJobtypeCodes', jobtypeCodes)
      },
      hide () {
        this.$emit('hide')
      },
      async recommendJobtype () {
        this.$store.commit('common/lockGlobal')
        try {
          this.isLoading = true
          const result = await api.getJobtypeAi(this.jobtypeText)

          result.forEach((r) => {
            this.jobtypeCodes = this.jobtypeCodes.concat(Object.values(r)[0])
          })

          this.isLoading = false
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
          this.isLoading = false
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobtypeModal.vue